/**
 * Central source of truth for VELOTEKA contact & business info.
 *
 * Update this file to change contact information everywhere it appears in the
 * frontend — Footer, ContactPage, JSON-LD SEO tags, mailto: links, etc.
 *
 * Backend mirror at /app/backend/site_info.py — keep the two in sync.
 */

export const CONTACT_EMAIL = "info@veloteka.de";
export const MAILTO = `mailto:${CONTACT_EMAIL}`;

// Both physical locations of the business — displayed together on the
// Contact page and in the Footer.
export const ADDRESSES = [
  {
    label: "Macedonia",
    line1: "Sava Kovacevik 18a",
    line2: "Strumica, Macedonia",
    country: "Macedonia",
  },
  {
    label: "Germany",
    line1: "Gschnaidtstr. 7",
    line2: "Deggendorf, Germany",
    country: "Germany",
  },
];

export const BUSINESS_NAME = "VELOTEKA";
export const WEBSITE_URL = "https://veloteka.de";

// Existing WhatsApp number kept as-is (user did not ask for a phone change).
export const WHATSAPP_URL = "https://wa.me/4917630116280";
export const WHATSAPP_DISPLAY = "+49 176 30116280";

export const SOCIAL = {
  instagram: "https://instagram.com/veloteka.eu",
  facebook: "https://www.facebook.com/velOteka1/",
  whatsapp: WHATSAPP_URL,
};

// Shorthand for "primary" address string used in copy where a single line fits.
export const PRIMARY_ADDRESS_LINE = `${ADDRESSES[0].line1}, ${ADDRESSES[0].line2}`;

const siteInfo = {
  CONTACT_EMAIL, MAILTO, ADDRESSES, BUSINESS_NAME, WEBSITE_URL,
  WHATSAPP_URL, WHATSAPP_DISPLAY, SOCIAL, PRIMARY_ADDRESS_LINE,
};
export default siteInfo;
